var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFezes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.08 22.02",
    width: "26px",
    height: "26px",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2-2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "1.92 7.92 4.02 7.92 4.02 19.98 18.18 19.98 18.18 7.92 20.1 7.92 20.1 22.02 1.92 22.02 1.92 7.92"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 22.08,
    height: 5.82
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.77,20c-1.18-2.49.7-3.17,1.43-3.34a.29.29,0,0,0,.21-.31,2.1,2.1,0,0,1,.47-1.25,1.71,1.71,0,0,1,.95-.65c1.86-.49,2.09-1.55,2.21-2.15a.29.29,0,0,1,.38-.21c3.43,1.28,1.72,4.55,1.71,4.55h0A2.37,2.37,0,0,1,15.33,20a.29.29,0,0,1-.25.16H7A.3.3,0,0,1,6.77,20Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFezes);
export default __webpack_public_path__ + "static/media/fezes.6d083858c7e212e8427da61adc34202e.svg";
export { ForwardRef as ReactComponent };